import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetInvoicesResponse } from "./getInvoicesRequest.schema";

/**
 * @description
 * Fetches all invoices for a company.
 * Optionally filters invoices by a search string (matches invoice number or customer name).
 *
 * Sends GET request to la-forge route:
 * GET /api/invoices?companyID={companyID}&search={search}
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param companyID - company ID for which to fetch invoices
 * @param search - optional search string to filter invoices
 * @returns list of invoices
 */
export const getInvoices =
  (axios: IAxiosInstance) =>
  async (
    companyID: string,
    search: string = ""
  ): Promise<TGetInvoicesResponse> => {
    const response = await axios.noRetry.get("/api/invoices", {
      params: { companyID, search },
    });

    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error fetching invoices");
  };
